import React, { useRef } from 'react';
import Close from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../Features/orderDetailsSlice';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';

function RejectReason({ rejectReason }) {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    return (
        <div ref={wrapperRef} className="font-urbanist-regular w-[45%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Reason for Rejection</h1>

                <button onClick={handleCloseButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <p className='font-medium text-base text-[#121212]'>{rejectReason}</p>
        </div>
    )
}

export default RejectReason;
